/**
 * Created by Simon Zhao on 7/29/21.
 * Description:
 * The dropdown item for each MDL provider candidate.
 * ------ maintenance history ------
 */
import { Component, Input, OnInit } from '@angular/core';
import { businessConstants } from '../../../../constants/business.constants';
import { Dataprovider } from '../../../../tamalelibs/models/dataprovider.model';

@Component({
    selector: 'tam-mdl-dialog-field-section-provider-item',
    templateUrl: './mdl-dialog-field-section-provider-item.component.html',
    styleUrls: ['./mdl-dialog-field-section-provider-item.component.scss']
})
export class MdlDialogFieldSectionProviderItemComponent implements OnInit {

    @Input() itemData: Dataprovider = new Dataprovider();

    constructor() { }

    getDSTypeName(code: number): string {
        return businessConstants.dataSourceTypeMap[code];
    }

    ngOnInit() {
    }

}
